import Vapi from 'vuex-rest-api'
const user = new Vapi({
  state: {
    user: {
      Valid: false,
    },
  },
}).get({
  action: 'getUser',
  property: 'user',
  path: '/api/v2/tunnels/User',
  onSuccess (state, payload, axios, { params, data }) {
    state.user = payload.data.data
    state.user.Valid = true
  },
  onError (state, error, axios, { params, data }) {
    state.user = { Valid: false }
  },
}).getStore({ namespaced: true })

export default user
